import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ColoredButton from "../../../shared/components/ColoredButton";

const styles = theme => ({
  termsConditionsListitem: {
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(1)
  },
  dialogActions: {
    justifyContent: "flex-start",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  backIcon: {
    marginRight: theme.spacing(1)
  }
});

function TermsOfServiceDialog(props) {
  const { classes, onClose, theme } = props;
  return (
    <Dialog open scroll="paper" onClose={onClose} hideBackdrop>
      <DialogTitle>Terms and Conditions</DialogTitle>
      <DialogContent>
        <Typography variant="h6" color="primary" paragraph>
          Introduction
        </Typography>
        <Typography paragraph>
        These Terms and Conditions ("Agreement") are entered into by and between Auralyze.ai ("Auralyze," "we," "us," or "our") and the user ("you," "your," or "user"). This Agreement governs your use of Auralyze.ai's services, including but not limited to the website, applications, and content.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        1. Acceptance of Terms
        </Typography>
        <Typography paragraph>
        By using Auralyze.ai's services, you agree to comply with and be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
         2.1 Data Collection
        </Typography>
        <Typography paragraph>
        Auralyze.ai collects and processes user data, including but not limited to videos, emails, and other information provided during your use of our services. We collect this data to provide our educational services effectively.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        2.2 Data Storage
        </Typography>
        <Typography paragraph>
        User videos and data are securely stored on AWS, a trusted cloud storage provider. We implement appropriate security measures to protect your data.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        2.3 Data Usage
        </Typography>
        <Typography paragraph>
        Your data, including videos and personal information, may be used for improving our services, research, and analytics. We do not share your data with third parties without your consent, except as required by law.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        2.4 GDPR Compliance
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        2.4.1 Consent
        </Typography>
        <Typography paragraph>
        By using our services, you consent to the collection, processing, and storage of your data as described in this Agreement.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        2.4.2 Data Subject Rights
        </Typography>
        <Typography paragraph>
        As a user, you have the right to access, rectify, and delete your personal data. You may also request data portability and object to data processing. To exercise these rights, please contact us at support@auralyze.ai.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        2.4.3 Data Security
        </Typography>
        <Typography paragraph>
        We implement appropriate technical and organizational measures to protect your data. However, no data transmission over the internet is completely secure. While we strive to protect your data, we cannot guarantee its absolute security.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        2.4.4 Privacy Policy
        </Typography>
        <Typography paragraph>
        For more information on data collection, processing, and your rights, please refer to our Privacy Policy which is available at request to support@auralyze.ai.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        3.1 User Age
        </Typography>
        <Typography paragraph>
        Our services are intended for users aged 16 and over. Users under the age of 16 may use our services with parental or guardian consent.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
          3.2 One User, One Account Policy
        </Typography>
        <Typography paragraph>
        Each Auralyze.ai account is intended for individual use. Sharing accounts is not permitted. To ensure the best experience for all users and to maintain the security of your data, please make sure that each user has their own account, and that you do not share your account with others.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        4. Termination
        </Typography>
        <Typography paragraph>
        We reserve the right to terminate or suspend your access to our services at our discretion, without notice, for any reason, including breach of these Terms and Conditions.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        5. Changes to Terms and Conditions
        </Typography>
        <Typography paragraph>
        Auralyze.ai may modify these Terms and Conditions at any time. Changes will be effective immediately upon posting on our website. Continued use of our services after changes are made constitutes acceptance of the modified terms.
        </Typography>
        <Typography variant="h6" color="primary" paragraph>
        Contact Information
        </Typography>
        <Typography paragraph>
        For questions or concerns regarding these Terms and Conditions or our GDPR compliance, please contact us at support@auralyze.ai.
        By using Auralyze.ai's services, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.
        </Typography>
        <Typography>
        Last updated: 14 Nov 2023
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <ColoredButton
          onClick={onClose}
          variant="contained"
          color={theme.palette.common.black}
        >
          <ArrowBackIcon className={classes.backIcon} />
          Back
        </ColoredButton>
      </DialogActions>
    </Dialog>
  );
}

TermsOfServiceDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(TermsOfServiceDialog);
